import React from 'react';
import classNames from 'classnames';
import { Link } from 'gatsby';

import { MenuItem } from '@layouts/Navigation/NavigationProps';

import * as styles from '../../Navigation.module.scss';

export const NavSections: React.FC<{ menuItem: MenuItem }> = ({ menuItem }) => {
	return (
		<div className={styles.menuSections}>
			{menuItem.sections.map((section, index) => (
				<div
					key={`${section.sectionName}`}
					className={classNames(
						styles.section,
						section.links.length <= 4 ? styles.oneColumn : styles.twoColumns
					)}
				>
					<div className={classNames(styles.sectionName, 'font-600 pb-3')}>
						{section.sectionName}
					</div>
					<div className={classNames(styles.sectionLinks, 'container')}>
						<div className="row p-0">
							{section.links.map((item) => (
								<Link
									key={`${item.name + item.url}`}
									className={classNames(
										styles.sectionLink,
										section.links.length > 4 ? 'col-6' : 'col-12',
										'font-300 p-0 d-flex align-items-center'
									)}
									to={menuItem.url + item.url}
									partiallyActive={true}
								>
									<img src={item.icon} className="mr-2" />
									<span>{item.name}</span>
								</Link>
							))}
						</div>
					</div>
					{index < menuItem.sections.length - 1 && (
						<div className={styles.separator} />
					)}
				</div>
			))}
		</div>
	);
};
